import React from 'react';
import { usePleriRender } from '../context/PleriRenderContext';
import { PleriLogo } from './PleriLogo';
import { PleriStatusGate } from '../client/PleriStatusGate';
import { pleriRouter } from '../../../Pleri';

import { useTranslation } from 'react-i18next';

interface PleriTriggerButtonProps {
  className?: string;
}

/**
 * PleriTriggerButton - Can be used anywhere to open Pleri
 *
 * Use this in your navbar, toolbar, or anywhere in your app
 * when renderType is 'navbar' or 'custom'
 */
export const PleriTriggerButton: React.FC<PleriTriggerButtonProps> = ({
  className = '',
}) => {
  const { t } = useTranslation('pleri/chat');
  const { toggle, isOpen, renderType } = usePleriRender();

  if (renderType !== 'navbar') {
    return null;
  }
  const navigate = pleriRouter.navigate;

  const handleClick = () => {
    toggle();
    if (!isOpen) {
      navigate({
        to: '/c/$conversationId',
        params: { conversationId: 'new' },
      });
    }
  };

  return (
    <PleriStatusGate>
      <div id="search-app">
        <button
          onClick={handleClick}
          className={`flex items-center gap-2 rounded-lg border-2 border-[#FF732E] px-2 py-1.5 transition-all duration-200 ${
            isOpen ? 'bg-[#FF732E]/10' : 'bg-transparent hover:bg-[#FF732E]/5'
          } ${className}`}
          aria-label={t('askPleri')}
        >
          <PleriLogo size={20} className="rounded-md" />
          <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
            {t('askPleri')}
          </span>
        </button>
      </div>
    </PleriStatusGate>
  );
};
